import { render } from "./ProjectBtn.vue?vue&type=template&id=7827b0f4&scoped=true"
import script from "./ProjectBtn.vue?vue&type=script&lang=js"
export * from "./ProjectBtn.vue?vue&type=script&lang=js"

import "./ProjectBtn.vue?vue&type=style&index=0&id=7827b0f4&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7827b0f4"]])

export default __exports__